import React, { Component } from "react";
import "./fdhome.css";
import { t } from "i18next";
import FDProfile from "../../../assets/svgs/fasset/fd_home.svg";
import {
  BreadCrumb,
  Button,
  TitleView,
  SideModel,
} from "../../components";
import * as Bl from "../../../businesslogic";
import { INVESTMENT_CATEGORY } from "../../constants";
import { getFinancialNonMarketPath, getUserId } from "../../common";

const newInvestment = {
  investmentcategory: INVESTMENT_CATEGORY.FIXED_DEPOSIT,
  currentvalue: 0,
  annualcontribution: 0,
  maturityyear: 0,
  maturityvalue: 0,
  expectedror: 0,
  userid: "",
  contributiongrowthrate: 0,
  investementtype: "YEAR",
  investmentdetails: [
    {
      isfliberadvise: false
    },
  ],
  investmentdescription: "",
  fvatretirement: 0,
  maturityage: 0,
  userage:0,
  isincludefinancialplan: false
};
class FDHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newInvestmentData: new Bl.Investment({...newInvestment, userid: getUserId()}),
      investmentData: [],
    };
  }

  onSelectItem(path) {
    this.props.navigate(path);
  }

  onPressSaveButton() {
    this.props.navigate("/fddetailpage", {
      state: {
        investmentData: this.state.newInvestmentData,
        isEditView: false,
      },
    });
  }

 
  renderNavView() {
    const items = getFinancialNonMarketPath("FD");
    const location = this.props.location;
    return (
      <BreadCrumb
        items={items}
        isLastPath={true}
        currentPath={location.pathname}
        onClickBackIcon={this.onSelectItem.bind(this)}
        onClickItem={this.onSelectItem.bind(this)}
      />
    );
  }

  renderTitleView() {
    const title = t("networthAssetsFNM2");
    return <TitleView title={title} />;
  }

  renderProfileView() {
    return (
      <div className="fd_profile_view">
        <img
          src={FDProfile}
          alt={t("networthAssetsFNM2")}
          className="fd_icon"
        />
        <div className="fd_save">
          <Button
            buttonName={t("fdButton")}
            onPressButton={this.onPressSaveButton.bind(this)}
          />
        </div>
      </div>
    );
  }

  renderContentView() {
    return (
      <div className="fd_content_view">
        {this.renderTitleView()}
        {this.renderProfileView()}
      </div>
    );
  }
  renderDrawerContent() {
    const headerTitle = t("financialPlan");
    const step = 1;
    return <SideModel step={step} headerTitle={headerTitle}></SideModel>;
  }
  render() {
    return (
      <div className="fd_container">
        {this.renderNavView()}
        {this.renderContentView()}
        {/* {this.renderDrawerContent()} */}
      </div>
    );
  }
}

export default FDHome;
